export default {
    layout: {
        zh: '簡体字中国語',
        zhTw: '繁体字中国語',
        en: '英語',
        kr: '韓国語',
        jp: '日本語',
        copyAddress: 'アドレスをコピー',
        switchWallet: 'ウォレット切替',
        disconnect: '切断',
        copied: 'コピーしました',
        failed:'failed',
        success:'success',
    },
    node: {
        progress: '処理中',
        executionSuccessful: '成功',
        at: '',
        view: '確認',
    },
    menu: {
        home: 'ホーム',
        exchange: '交換',
        mining: 'マイニング',
        assets: '資産',
        earnings: '収益',
        me: 'マイ',
        notice: 'お知らせ',
    },
    exchange: {
        title: '交換',
        send: '送信',
        receive: '受信',
        obtain: '獲得',
        consume: '消費',
        balance: '残高',
        max: '最大',
        currentPrice: '現在価格',
        submit: '交換',
        records: '交換履歴',
        price: '価格',
        success: '成功',
        fail: '失敗',
    },
    home: {
        brand: 'OnOx',
        slogan: '世界をつなぎ、未来を拓く',
        sloganDesc: '分散型・オープン・高効率',
        yield: '利回り',
        notice: 'お知らせ1、ABCマイニング開始',
        todayOutput: '本日のプール産出',
        networkHashrate: 'ネットワーク有効ハッシュレート',
        price: '現在価格',
        burned: '総バーン量',
        aboutTitle: 'ONOXハッシュレートマイニングについて',
        aboutDesc: 'ONOXは実ハッシュレートノードを接続し、産出・精算・資産を信頼できるモバイル口座に統合します。',
        featureHashrate: '実ハッシュレート接続',
        featureHashrateDesc: 'ノード状態は透明、データはリアルタイム更新',
        featureDaily: '毎日収益精算',
        featureDailyDesc: '有効ハッシュレートで課金、記録は追跡可能',
        featureSecurity: 'デジタル資産の安全',
        featureSecurityDesc: 'ウォレット紐付けと出金の多要素認証',
        bindTitle: '招待アドレスを紐付け',
        bindConfirm: '確認',
        bindPlaceholder: '0x000000000000000000000000000000',
    },
    mining: {
        title: 'バーンマイニング',
        subtitle: 'ハッシュレートを有効化し収益を共有',
        totalT: '合計 (T)',
        shareT: 'シェア',
        teamT: 'チーム',
        burnT: 'バーン',
        validBurnT: '有効バーン',
        renew: '更新',
        amountPlaceholder: 'バーン数量を入力',
        token: 'バーン通貨',
        rate: 'リアルタイム換算',
        balance: 'ウォレット残高',
        submit: 'バーンマイニングに参加',
        hint: '実際に1.002のバーンハッシュレートを獲得',
        burnLog: 'バーン記録',
        shareLog: 'シェア',
        renewLog: '更新記録',
        success: '成功',
        fail: '失敗',
        qty: '数量',
        hashrateT: 'ハッシュレート (T)',
        renewHashrate: '更新ハッシュレート',
        renewFee: '更新費用',
        renewDate: 'ハッシュレート期間',
        renewConvert: '換算数量',
        renewNote: '説明',
        renewNoteText: '2026.10.1までに更新してください。期限を過ぎるとマイニング収益を得られません。',
        renewConfirm: '更新を確認',
        ext1:'報酬ハッシュレート',
        ext2:'マイニング収益',
        ext3:'契約更新金額'
    },
    earnings: {
        balance: '資産残高',
        recharge: '入金',
        withdraw: '出金',
        totalWithdraw: '累計出金',
        totalIncome: '総収益',
        mineIncome: 'マイニング収益',
        referral: '紹介報酬',
        incomeLog: '収益記録',
        rechargeLog: '入金記録',
        withdrawLog: '出金記録',
        qty: '数量',
        success: '成功',
        pending: '振込待ち',
        fail: '失敗',
        rechargeQty: '入金数量',
        withdrawQty: '出金数量',
        receiveQty: '着金数量',
        rechargeTitle: '入金',
        withdrawTitle: '出金',
        rechargeMin: '10未満不可',
        minAmount: '100未満不可',
        toAccount: '着金予定',
        fee: '手数料',
        rechargeAddress: '入金アドレス',
        address: '出金アドレス',
        confirmRecharge: '入金を確認',
        confirmWithdraw: '出金を確認',
    },
    me: {
        inviteLink: '招待リンク',
        upline: '上位アドレス',
        inviteCount: '招待人数',
        teamCount: 'チーム人数',
        bigArea: '大エリア (T)',
        smallArea: '小エリアバーン (T)',
        team: 'チームメンバー',
        direct: '直接',
        indirect: '間接',
        umbrella: '傘下',
        burnT: 'バーン (T)',
        personT: '個人 (T)',
        teamBurn: 'チームバーン (T)',
        teamHash: 'チームハッシュレート (T)',
        remark: 'メモ',
        setRemark: 'メモ設定',
        remarkPlaceholder: 'メモを入力',
        confirm: '確認',
    },
    notice: {
        title: 'お知らせ詳細',
        headline: '見出し見出し見出し見出し',
        date: '2024-12-22',
        body: 'ユーザー各位\n\nXXXAppは2024年11月26日20時に正式リリースします。',
    },
};
